import React from 'react';
import { CtaButton } from './CtaButton';
import { MegapackMockup } from './MegapackMockup';
import { price } from '../../data/landing';
export function Hero() {
  return <section aria-labelledby="hero-title" className="bg-cream pb-14 pt-10 md:pb-20 md:pt-16" style={{
    paddingBottom: "42px"
  }} data-id="element-95" data-mp="2sbzzslo0o0cy">
      <div className="mx-auto max-w-6xl px-5 text-center" data-id="element-96" data-mp="2ikm4kq33lmpm">
        <p className="text-sm font-extrabold uppercase tracking-[0.12em] text-primary md:text-base" data-id="element-97" data-mp="2ihzvun4h115t">
          ¿Sos psicóloga o terapeuta infantil?
        </p>
        <h1 id="hero-title" className="mx-auto mt-4 max-w-4xl font-serif text-[2.6rem] leading-[1.02] text-ink sm:text-6xl md:text-7xl" data-id="element-98" data-mp="29icvm4nha1ec">
          Tené todo tu año de sesiones resuelto en solo <em className="text-primary" data-id="element-99" data-mp="1zm02b7vuhpk4">5 minutos</em>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-muted md:text-xl" data-id="element-100" data-mp="2soewzbnn8xf">
          Actividades y recursos terapéuticos listos para usar, organizados por objetivos para que dejes de perder
          tiempo buscando qué hacer en cada sesión.
        </p>

        <MegapackMockup className="mt-10 md:mt-14" data-id="element-101" data-mp="lwxb5h1mdzmm" />

        <div className="mt-10 flex flex-col items-center md:mt-12" data-id="element-102" data-mp="pwo862hqpbzl">
          <CtaButton data-id="element-103" data-mp="bwmybxjhyu7z">Quiero tener mis sesiones resueltas</CtaButton>
          <p className="mt-4 text-sm text-muted" data-id="element-104" data-mp="byhhb6b7kc9f">
             Descarga inmediata · Acceso de por vida
          </p>
        </div>

        
      </div>
    </section>;
}